import logo from "../../../../assets/img/logo.png"
import FooterData from "./varaibles/FooterData";
import {APP_NAME} from "../../../../settings/settings";
import {Link} from "react-router-dom";
import {MdEmail} from "react-icons/md";
import {AiFillInstagram, AiFillYoutube} from "react-icons/ai";
import {BsTiktok} from "react-icons/bs";

const support = [
    // {
    //     name: "Help Center",
    //     href: "/help-center"
    // },
    // {
    //     name: "Contact Us",
    //     href: "/contact-us"
    // },
    {
        name: "Terms of use",
        href: "/terms-of-use"
    },
    {
        name: "Privacy Policy",
        href: "/privacy-policy"
    }
]

export default function Footer({className, ...props}) {

    return (
        <div
            className={`bg-gray-150  flex flex-col gap-6 bg-[#012F54] pt-[12px] lg:pb-[12px] lg:pt-[124px] lg:px-[148px]  ${className}`}>
            <div className={"flex flex-col gap-4 lg:flex-row justify-between "}>
                <div className={"w-full lg:w-[583px] gap-2 flex flex-col mb-3 "}>
                    <div className={"flex -ml-4"}>
                        <img alt={logo}
                             className={'h-12 md:h-14 lg:h-16 w-auto'}
                             src={logo}/>
                    </div>
                    <p className={"lg:pr-20 text-sm text-white lg:text-base"}>
                        With 15+ years of certified Duolingo and TOEFL instruction, I lead DET Study in
                        transforming language education. Our platform offers 15,000+ AI-scored sample
                        questions with instant feedback and regular updates to match the evolving Duolingo
                        English Test. Experience the future of language proficiency with DET Study, supported
                        by our skilled development team for a seamless, innovative learning.
                    </p>
                </div>

                <div className={" grid grid-cols-2 gap-[12px] lg:gap-[75px]"}>
                    <div className={"flex flex-col gap-[8px]"}>
                        <p className={"font-semibold text-white"}>
                            Support
                        </p>
                        <div className={"flex flex-col gap-[4px]"}>
                            {
                                support.map((item, index) => (
                                    <Link key={index} to={item.href}
                                          className={"text-sm text-gray-300 hover:text-white"}>
                                        {item.name}
                                    </Link>
                                ))
                            }

                        </div>

                    </div>
                    <div className={"flex flex-col gap-[8px]"}>
                        <p className={"font-semibold text-white"}>
                            Contact
                        </p>
                        <div className={"flex text-white flex-col gap-[4px]"}>
                            <p className={"max-w-[236px]"}>
                                Follow us for tips, updates, and study strategies:
                            </p>
                            <div className={"flex mt-2 flex-row gap-2 items-center text-white"}>
                                <MdEmail/>
                                <a href={`mailto:detstudynow@gmail.com`}>
                                    detstudynow@gmail.com
                                </a>
                            </div>
                            <div className={"flex mt-2 flex-row text-white gap-2 items-center"}>

                                <Link target={"_blank"} to={"https://www.youtube.com/@detstudy/featured"}>
                                    <AiFillYoutube/>
                                </Link>
                                <Link target={"_blank"}
                                      to={"https://www.instagram.com/detstudynow?igsh=MXI4NnhiaHI4MXE4cw=="}>
                                    <AiFillInstagram/>
                                </Link>
                                <Link target={"_blank"}
                                      to={"https://www.tiktok.com/@detstudy?is_from_webapp=1&sender_device=pc"}>
                                    <BsTiktok/>
                                </Link>

                            </div>


                        </div>

                    </div>

                </div>


            </div>
            <div className={"flex flex-col"}>
                <img src={"/images/duo_wave.svg"} alt={"duo_wave"}
                     className={"w-[88px] hidden lg:block self-end"}
                />
                <div className={"w-full border-t-[1px]  border-gray-300 "}/>
            </div>
            <div className={"flex flex-col justify-center gap-2 lg:flex-row text-sm px-10 items-center mb-2 "}>
                <p className={"text-center text-white "}>
                    {APP_NAME} © 2020-{
                    new Date().getFullYear()
                }, All Rights Reserved
                </p>


            </div>

        </div>

    )
}
